import React from 'react';
import ReactDOM from 'react-dom/client';
import { applyDesignV2Flag } from './theme/applyDesignV2Flag';
import './theme/fonts.css';
import App from './App';

applyDesignV2Flag();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/** Remove splash HTML após o primeiro paint do React (só relevante no mobile). */
function dismissAppSplash() {
  const splash = document.getElementById('app-splash');
  if (!splash) return;

  if (!window.matchMedia('(max-width: 768px)').matches) {
    splash.remove();
    return;
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      splash.classList.add('app-splash--hide');
      window.setTimeout(() => splash.remove(), 280);
    });
  });
}

dismissAppSplash();
